import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { CountryCode } from '@/store/ui';
import { CustomerProfile } from '@/models';
import { AccountManagementEvent } from '@/services/analytics/events';
import { LoginCompleteEvent } from '@/services/analytics/events/login-complete-event';

@Component({
  name: 'CmgSignIn',
})
export default class CmgSignIn extends Vue {
  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get logoImageSrc(): string {
    let src = '';
    if (this.countryCode == CountryCode.US) {
      src = this.$appStore.state.cms.signInContentFragment?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
    } else if (this.countryCode == CountryCode.CA) {
      src = this.$appStore.state.cms.signInContentFragment?.imageUrl || this.$appStore.state.cms.images.logos.medallion.default;
    }
    return src;
  }

  get withPaddingBottom(): boolean {
    return this.$router.currentRoute.name !== Routes.VendorSignIn;
  }

  get signInFormProps(): object {
    return this.$router.currentRoute.name === Routes.VendorSignIn
      ? {
          initialFormState: { rememberMe: false },
          renderRememberMe: false,
          renderCountryFlag: false,
        }
      : {};
  }

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return profile && !profile.isGuest ? profile : null;
  }

  get headingText(): string {
    return  this.$router.currentRoute.name === Routes.VendorSignIn 
      ? 'Join Chipotle Rewards Or Sign In To Play'
      : this.$appStore.state.cms.signInContentFragment?.heading || 'Sign In';
  }

  onSignIn(): void {
    if (this.$router.currentRoute.name === Routes.VendorSignIn) {
      return;
    }
    const path = this.$route.query['path'] as string;
    if (path) {
      this.$router.replace(path);
    } else {
      this.$router.replace({ name: Routes.Home });
    }
    
    this.$services.analytics.send(new LoginCompleteEvent());
    this.$services.adobeTarget.sendAdobeTargetExperienceRequest(this.$route.name); 
    this.$services.analytics.send(new AccountManagementEvent('logins'));
  }
}
